import { useSelector } from "react-redux";
import ThinBag from "../../../Helpers/icons/ThinBag";
import Middlebar, { DropDown } from "./Middlebar";
import SearchBox from "../../../Helpers/SearchBox";
import Navbar from "./Navbar";
import TopBar from "./TopBar";
import { useEffect, useState } from "react";
import { ErrorToaster, SuccessToaster } from "../../../Helpers/toaster/Toaster";
import AuthServices from "../../../../apis/auth/AuthServices";
import Drawer from "../../../Mobile/Drawer";
import CategoryServices from "../../../../apis/category/CategoryServices";
import { Alert, Avatar, Box, Typography } from "@mui/material";
import { useAuth } from "../../../../context/UseContext";
import VerifyOtp from "../../../VerifyOtp";
import { baseUrl } from "../../../../config/axios";
import { Link } from "react-router-dom";
import { getLoginUrl } from "../../../../utils";

export default function HeaderOne({ className, type = 1 }) {

  const { user, userLogin } = useAuth();
  const { cart } = useSelector(state => state.userDataReducer)

  const [drawer, setDrawer] = useState(false);
  const [userTypes, setUserTypes] = useState([]);

  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  const [fullBaseUrl, setFullBaseUrl] = useState('');

  const [openOtpDialog, setOpenOtpDialog] = useState(false);

  const [loading, setLoading] = useState(false);
  const [otpVerificationError, setOtpVerificationError] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const openDropdown = Boolean(anchorEl);

  // *For Get User Types
  const getUserTypes = async () => {
    try {
      const { data } = await AuthServices.getUserTypes()
      setUserTypes(data)
    } catch (error) {
      ErrorToaster(error)
    }
  }

  // *For Get Categories
  const getCategories = async () => {
    try {
      let params = {
        search: '',
        page: 1,
        limit: 200
      }
      const { data, imageBaseUrl } = await CategoryServices.getCategories(params)
      setFullBaseUrl(imageBaseUrl)
      setCategories(data)
    } catch (error) {
      ErrorToaster(error)
    }
  }

  // *For Get Sub Categories
  const getSubCategories = async () => {
    try {
      let params = {
        search: '',
        page: 1,
        limit: 2000
      }
      const { data } = await CategoryServices.getSubcategories(params)
      setSubCategories(data)
    } catch (error) {
      ErrorToaster(error)
    }
  }

  // *For Verify OTP 
  const verifyOtp = async (otpCode) => {
    setLoading(true)
    try {
      const obj = {
        whatsapp_number: user?.whatsapp_number,
        whatsapp_code: otpCode?.whatsappOtpCode,
      }
      const { message } = await AuthServices.verifyOtp(obj)
      SuccessToaster("Number verified successfully.");
      const updatedData = { ...user, iswhatsappverified: true }
      userLogin(updatedData)
      setOpenOtpDialog(false)
    } catch (error) {
      setOtpVerificationError(true)
      ErrorToaster(error);
    } finally {
      setLoading(false)
    }
  }

  // *For Resend Code
  const sendWhatsAppOtp = async () => {
    try {
      const obj = {
        phone_number: user?.whatsapp_number
      }
      const { message } = await AuthServices.sendWhatsAppOtp(obj)
      SuccessToaster(message);
      setOpenOtpDialog(true)
    } catch (error) {
      ErrorToaster(error);
    }
  }

  useEffect(() => {
    getUserTypes()
    getCategories()
    getSubCategories()
  }, []);

  return (
    <>
      <VerifyOtp
        loading={loading}
        error={otpVerificationError}
        open={openOtpDialog}
        otpNumber={user?.whatsapp_number}
        register={verifyOtp}
      />

      <Drawer
        open={drawer}
        action={() => setDrawer(!drawer)}
        categories={categories}
        subCategories={subCategories}
        fullBaseUrl={fullBaseUrl}
      />
      <header className={`${className || ""} header-section-wrapper relative`}>
        <TopBar className="quomodo-shop-top-bar" userTypes={userTypes} />
        <Middlebar type={type} className="quomodo-shop-middle-bar lg:block hidden" />
        <div className="quomodo-shop-drawer lg:hidden block w-full h-[60px] bg-white">
          <div className="w-full h-full flex justify-between items-center px-3">
            <div onClick={() => setDrawer(!drawer)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 6h16M4 12h16M4 18h7"
                />
              </svg>
            </div>
            <div>
              {type === 3 ? (
                <a href="/">
                  <img
                    className="logo"
                    src={`${process.env.PUBLIC_URL}/assets/images/hashtag-logo.png`}
                    alt="hashtag"
                  />
                </a>
              ) : type === 4 ? (
                <a href="/">
                  <img
                    className="logo"
                    src={`${process.env.PUBLIC_URL}/assets/images/hashtag-logo.png`}
                    alt="hashtag"
                  />
                </a>
              ) : (
                <a href="/">
                  <img
                    className="logo"
                    src={`${process.env.PUBLIC_URL}/assets/images/hashtag-logo.png`}
                    alt="hashtag"
                  />
                </a>
              )}
            </div>
            <div className="flex justify-between items-center space-x-4">
              <div className="cart relative cursor-pointer">
                <a href="/cart">
                  <span>
                    <ThinBag />
                  </span>
                </a>
                <span className={`badge w-[18px] h-[18px] rounded-full  absolute -top-2.5 -right-2.5 flex justify-center items-center text-[9px] ${type === 3 ? 'bg-qh3-blue text-white' : 'bg-qyellow text-qblack'}`}>
                  {cart?.length}
                </span>
              </div>
              {user?.token ? (
                <Box sx={{ cursor: 'pointer' }} onClick={(e) => setAnchorEl(e.currentTarget)}>
                  <Avatar
                    src={user?.image ? baseUrl + "/user_image/" + user?.id + '/' + user?.image : undefined}
                    sx={{
                      width: 40,
                      height: 40,
                      border: `1px solid #009640`,
                      '.MuiAvatar-img': { objectFit: 'contain' }
                    }}
                  />
                </Box>
              ) : (
                <Link to={getLoginUrl()}>
                  <div className="black-btn w-[120px] h-[40px] flex justify-center items-center cursor-pointer">
                    <div className="flex space-x-2 items-center">
                      <span className="text-sm font-600">Login</span>
                    </div>
                  </div>
                </Link>
              )}
              <DropDown anchorEl={anchorEl} openDropdown={openDropdown} handleClose={() => setAnchorEl(null)} />
            </div>
          </div>
        </div>
        <div className="lg:hidden w-full bg-white border-b border-qgray-border px-3 py-2">
          <div className="h-[44px]">
            <SearchBox type={type} className="search-com" />
          </div>
        </div>
        {!user?.token && (
          <div className="lg:hidden w-full bg-white border-b border-qgray-border px-3 py-2 flex justify-center">
            <Link
              to="/guest-register"
              state={{ userType: userTypes.find(e => e.label === 'Guest Buyer')?.value }}
              className="bgcolor text-white w-full max-w-[300px] h-[38px] flex justify-center items-center cursor-pointer rounded-full"
            >
              <div className="flex space-x-2 items-center">
                <span className="text-sm font-600">Register Now</span>
                <span>
                  <svg className="fill-current" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1.08984" width="6.94106" height="1.54246" transform="rotate(45 1.08984 0)" fill="white" />
                    <rect x="6" y="4.9082" width="6.94106" height="1.54246" transform="rotate(135 6 4.9082)" fill="white" />
                  </svg>
                </span>
              </div>
            </Link>
          </div>
        )}
        <Navbar
          type={type}
          userTypes={userTypes}
          className="quomodo-shop-nav-bar lg:block hidden"
          categories={categories}
          subCategories={subCategories}
          fullBaseUrl={fullBaseUrl}
        />
        {(user && !user?.iswhatsappverified) &&
          <Alert severity="error">
            You have not verified your whatsapp number. You can resend verification code by{" "}
            <Typography component="span" onClick={() => sendWhatsAppOtp()} sx={{ color: '#518ecb', cursor: 'pointer' }}>
              clicking here
            </Typography>.
          </Alert>
        }
      </header>
    </>
  );
}
